import { decamelize } from 'helpers/camelize';
import {
  fetchWrapper,
  handleResponse,
  hcUrlV3,
  buildOpts,
  objectToQueryString,
} from 'services/RequestService/helpers';

export const getUserBehavioralDiscountConfirmation = async ({
  params: {
    basketWasInitiallySkipped,
    discountWasInitiallyClaimed,
    initialServings,
    menuSlug,
    userBehavioralDiscountId,
  },
}) => {
  const response = await fetchWrapper(
    hcUrlV3(
      `/weekly_baskets/${menuSlug}/user_behavioral_discounts/${userBehavioralDiscountId}/confirmation?${objectToQueryString(
        decamelize({
          basketWasInitiallySkipped,
          discountWasInitiallyClaimed,
          initialServings,
        })
      )}`
    ),
    buildOpts()
  );

  return handleResponse(response);
};
